import { useState, type FormEvent } from "react";
import { useTranslation } from "react-i18next";
import { Button } from "@crashx/ui";
import { chatApi, chatError } from "./chatApi.js";
import { getConnection } from "../../net/connection.js";

export function ChatAuthForm() {
  const { t } = useTranslation();
  const [register, setRegister] = useState(false);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [registered, setRegistered] = useState(false);
  async function submit(event: FormEvent<HTMLFormElement>) {
    event.preventDefault();
    if (busy) return;
    const data = new FormData(event.currentTarget);
    const credentials = { email: data.get("email"), password: data.get("password") };
    setBusy(true);
    setError(null);
    try {
      if (register) {
        await chatApi.register({ ...credentials, nick: data.get("nick") });
        setRegistered(true);
        setRegister(false);
      } else {
        await chatApi.login({ ...credentials, code: data.get("code") || undefined });
        getConnection().disconnect();
        getConnection().connect();
      }
    } catch (cause) {
      setError(chatError(cause));
    } finally {
      setBusy(false);
    }
  }
  return (
    <details>
      <summary>{t("chat.signIn")}</summary>
      <form onSubmit={(event) => void submit(event)} className="flex flex-col gap-2">
        {registered ? <p role="status">{t("chat.registered")}</p> : null}
        <label className="cx-field">
          {t("chat.email")}
          <input className="cx-input" name="email" type="email" autoComplete="username" required />
        </label>
        <label className="cx-field">
          {t("chat.password")}
          <input
            className="cx-input"
            name="password"
            type="password"
            minLength={register ? 12 : 8}
            maxLength={128}
            autoComplete={register ? "new-password" : "current-password"}
            required
          />
        </label>
        {register ? (
          <label className="cx-field">
            {t("chat.nick")}
            <input className="cx-input" name="nick" minLength={2} maxLength={32} required />
          </label>
        ) : (
          <label className="cx-field">
            {t("chat.code")}
            <input className="cx-input" name="code" autoComplete="one-time-code" />
          </label>
        )}
        {error ? (
          <p role="alert" className="text-danger">
            {t(error)}
          </p>
        ) : null}
        <Button type="submit" disabled={busy}>
          {t(register ? "chat.register" : "chat.signIn")}
        </Button>
        <Button variant="ghost" type="button" disabled={busy} onClick={() => setRegister(!register)}>
          {t(register ? "chat.haveAccount" : "chat.createAccount")}
        </Button>
      </form>
    </details>
  );
}
